import type { JSX, ButtonHTMLAttributes } from 'react';
import { useNavigateQuery } from '@CS/hooks';
import ButtonStyle from './Button.styles';
import type { MouseEvent } from 'react';
import { pushEvent } from '@CS/hooks';

type Child = JSX.Element | string;
type Children<Child> = Child | Child[];
type ClickEvent = MouseEvent<HTMLButtonElement>;

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  onClick?: (event: ClickEvent) => unknown;
  type?: 'button' | 'submit' | 'reset';
  children?: Children<Child>;

  secondary?: boolean;
  gtmConfig?: object;
  disabled?: boolean;
  primary?: boolean;

  purple?: boolean;
  shadow?: boolean;
  round?: boolean;
  small?: boolean;

  blank?: boolean;
  link?: string;
  text?: string;
  id?: string;
};

export const Button = ({
  text = '',
  gtmConfig,
  secondary,
  disabled,
  children,
  onClick,
  primary,
  purple,
  shadow,
  round,
  small,
  blank,
  link,
  id,
  ...props
}: ButtonProps) => {
  const navigate = useNavigateQuery();

  const onButtonClick = (event: ClickEvent) => {
    gtmConfig && pushEvent(gtmConfig);

    if (!link) onClick?.(event);
    else if (blank) open(link, '_blank');
    else navigate(link);
  };

  return (
    <ButtonStyle
      onClick={onButtonClick}
      $secondary={secondary}
      disabled={disabled}
      $primary={primary}
      $purple={purple}
      $shadow={shadow}
      $round={round}
      $small={small}
      {...props}
      id={id}
    >
      {text || children}
    </ButtonStyle>
  );
};
